import PlaneAction from "./PlaneAction.js";
import {lineUp} from "../planeSlice.js";
import {getRunwayHeading} from "../../assets/virtual-flyout/nav-calc.js";
import {getActiveRunway} from "../../assets/virtual-flyout/airport-service.js";

export default class LineUp extends PlaneAction {
    constructor(planeId, airport, runway=null) {
        super(planeId);
        this.airport = airport;
        this.runway = runway;
        this.heading = runway ? getRunwayHeading(runway) : null;
    }

    execute() {
        if (!this.runway) {
            const wind = this.getState().wind;
            const activeRunway = getActiveRunway(this.airport.code, wind.heading);
            this.runway = activeRunway.runway;
            this.heading = getRunwayHeading(this.runway);
        }

        this.log(`Lining up on runway ${this.runway}`);
        this.dispatch(lineUp({heading: this.heading}));
    }

    isComplete () {
        const planeState = this.getState();
        return planeState.heading === this.heading;
    }
}

